import { MetricSet } from "./metrics";

type PromiseExecutor<T> = (resolve: (value: T | PromiseLike<T>) => void, reject: (reason?: any) => void) => void;

export function createPromiseWithMetrics<T>(
  metrics: MetricSet | undefined,
  executor: PromiseExecutor<T>) {
  metrics?.call();
  return new Promise<T>(executor)
    .then(result => {
      metrics?.success();
      return result;
    }).catch(
      e => {
        metrics?.failure();
        throw e;
      }
    );
}
